export const NEXSET_TAB_IDS = {
  OVERVIEW: 'overview',
  SCHEMA: 'schema',
  RULES: 'rules',
  STATS: 'stats',
  NOTIFICATIONS: 'notifications',
  ACTIVITY: 'activity',
  ERROR_DATA: 'errorData',
  SHARE: 'share',
} as const;

export type NexsetTabId = (typeof NEXSET_TAB_IDS)[keyof typeof NEXSET_TAB_IDS];

export const TAB_METADATA: Record<NexsetTabId, { label: string; order: number }> = {
  [NEXSET_TAB_IDS.OVERVIEW]: { label: 'Overview', order: 1 },
  [NEXSET_TAB_IDS.SCHEMA]: { label: 'Schema', order: 2 },
  [NEXSET_TAB_IDS.RULES]: { label: 'Rules', order: 3 },
  [NEXSET_TAB_IDS.STATS]: { label: 'Stats', order: 4 },
  [NEXSET_TAB_IDS.NOTIFICATIONS]: { label: 'Notifications', order: 5 },
  [NEXSET_TAB_IDS.ACTIVITY]: { label: 'Activity', order: 6 },
  [NEXSET_TAB_IDS.ERROR_DATA]: { label: 'Error Data', order: 7 },
  [NEXSET_TAB_IDS.SHARE]: { label: 'Share', order: 8 },
};
